import { render } from "./PokemonPicture.vue?vue&type=template&id=eb722cbc&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=eb722cbc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\perez\\Proyectos\\Vue\\04-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb722cbc"]])

export default __exports__